import { render, staticRenderFns } from "./NbuInsuranceIntermediary.vue?vue&type=template&id=47ea7bf2&"
import script from "./NbuInsuranceIntermediary.vue?vue&type=script&lang=js&"
export * from "./NbuInsuranceIntermediary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports